import Api from './api';

const LrfService = {


    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/lrf/listar',
            params: params
        })
        return response
    },
    numLrf: async (params) => {
        return Api({
            method: 'get',
            url: '/lrf/numlrf',
            params: params
        })
    },
    buscar: (params) => {
        const response = Api.get(`/lrf/buscar?${params}`)
        return response
    },
    tipo: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/lrf/tipo',
            params: params
        })
        return response
    }
}

export default LrfService;